export const PrepurchasedLicenseItemsColumns = (onEditItem) => {
  return [
    {
      title: "No",
      dataIndex: "ItemNo",
      key: "ItemNo",
    },
    {
      title: "License Item",
      dataIndex: "LicenseItem",
      key: "LicenseItem",
    },
    {
      title: "Old Type",
      dataIndex: "OldType",
      key: "OldType",
    },
    {
      title: "Old License",
      dataIndex: "OldCodeLabel",
      key: "OldCodeLabel",
      render: (value) => (value === "N/A" ? "" : value || ""),
    },
    {
      title: "Old Price",
      dataIndex: "OldPrice",
      key: "OldPrice",
      render: (value) =>
        value != null && value !== "" ? `$ ${Number(value).toFixed(2)}` : null,
    },
    {
      title: "New Type",
      dataIndex: "NewType",
      key: "NewType",
    },
    {
      title: "New License",
      dataIndex: "NewCodeLabel",
      key: "NewCodeLabel",
    },
    {
      title: "New Price",
      dataIndex: "NewPrice",
      key: "NewPrice",
      render: (value) =>
        value != null && value !== "" ? `$ ${Number(value).toFixed(2)}` : null,
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: (value) =>
        value != null && value !== "" ? `$ ${Number(value).toFixed(2)}` : null,
    },
    {
      title: "",
      dataIndex: "",
      key: "",
    },
  ];
};
